module.exports = __webpack_public_path__ + "static/media/people1-min.e6b59e46.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/people1-min.png
// module id = 392
// module chunks = 0